import _ from 'lodash'

const phoneNumber = (rule, value, callback) => {
  let error
  if (value && !/^[+]*[\d]{6,}$/.test(value)) {
    error = `${rule.field} is invalid`
  }
  callback(error)
}

const phoneNumberWithoutCountryCode = (rule, value, callback) => {
  let error
  if (value && !/^[\d]{4,}$/.test(value)) {
    error = `${rule.field} is invalid`
  }
  callback(error)
}

const postCode = (rule, value, callback) => {
  let error
  if (value && !/^[0-9]+$/.test(value)) {
    error = `${rule.field} is invalid`
  }
  callback(error)
}

const number = (message, errorCondition) => (rules, value, callback) => {
  const numberValue = _.toNumber(value)
  if (value && (_.isNaN(numberValue) || errorCondition(numberValue))) {
    callback(message)
  } else {
    callback()
  }
}

export default {
  number,
  phoneNumber,
  phoneNumberWithoutCountryCode,
  postCode
}
